"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ProductCompare;
var React = require("react");
var Actions_1 = require("@src/compare/Actions");
function ProductCompare(props) {
    var product = props.product, toggleFavAction = props.toggleFavAction, favourites = props.favourites, state = props.state;
    React.useEffect(function () {
        (0, Actions_1.saveSession)(favourites);
    }, [favourites]);
    function tooltipText() {
        return (React.createElement("span", { style: { display: 'none' } }, "I Matinfo kan du sammenlikne ingredienser, n\u00E6ringsinnhold, allergener og merking for inntil tre produkter samtidig. Klikk for \u00E5 legge dette produktet til sammenlikningsfunksjonen."));
    }
    return (React.createElement("button", { "data-testid": "compareProductButton", disabled: favourites.filter(function (fav) { return fav.ARIDENT === product.ARIDENT; }).length, type: "submit", className: "btn btn-standard empty custom-tooltip", style: { position: 'relative' }, onClick: function (e) {
            return toggleFavAction(e, product, state.state, state.dispatch);
        } },
        "Sammenlign",
        tooltipText()));
}
